var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEth40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40.005,
    viewBox: "0 0 40 40.005",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 .005h40v40h-40z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m39.4 24.842a20 20 0 1 1 -14.564-24.242 20 20 0 0 1 14.564 24.242z",
    fill: "#fff",
    transform: "translate(0 -.001)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.429 6.047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m383.687 0-.187.636v18.459l.187.187 8.568-5.065z",
    fill: "#343434",
    transform: "translate(-375.119)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.568 0-8.568 14.217 8.568 5.065z",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.346 729.952-.106.129v6.575l.106.308 8.573-12.074z",
    fill: "#3c3c3b",
    transform: "translate(-378.777 -709.048)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.568 736.964v-7.012l-8.568-5.062z",
    fill: "#8c8c8c",
    transform: "translate(0 -709.048)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.07 481.289 8.568-5.065-8.568-3.895z",
    fill: "#141414",
    transform: "translate(-383.502 -462.008)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 476.225 8.568 5.065v-8.96z",
    fill: "#393939",
    transform: "translate(0 -462.008)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEth40);
export default __webpack_public_path__ + "static/media/ic_eth_40.5e255508ace6905c481553b55d27a0e4.svg";
export { ForwardRef as ReactComponent };